<template>
  <v-expand-transition>
    <v-card outlined class="rounded-0" v-show="open">
      <v-card-text class="pa-0">
        <v-simple-table dense class="house-table">
          <template>
            <thead>
            <tr>
              <th class="text-left text-caption text--secondary font-weight-medium">{{ $t('label.documentNumber') }}</th>
              <th class="text-left text-caption text--secondary font-weight-medium">{{ $t('label.shipper') }}</th>
              <th class="text-left text-caption text--secondary font-weight-medium">{{ $t('label.consignee') }}</th>
              <th class="text-left text-caption text--secondary font-weight-medium">{{ $t('label.clientFm') }}</th>
              <th class="text-left text-caption text--secondary font-weight-medium">{{ $t('label.clientTo') }}</th>
              <th class="text-left text-caption text--secondary font-weight-medium">{{ $t('label.billOfLading') }}</th>
              <th class="text-left text-caption text--secondary font-weight-medium">{{ $t('label.freightTerms') }}</th>
              <th class="text-left text-caption text--secondary font-weight-medium">{{ $t('label.equipment') }}</th>
              <th class="text-center text-caption text--secondary font-weight-medium">{{ $t('label.praticaActions') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(house, i) in houses" :key="i">
              <td class="font-weight-bold primary--text">{{ house.documentNbr }}</td>
              <td>{{ house.shipperName || '-' }}</td>
              <td>{{ house.consigneeName || '-' }}</td>
              <td>{{ house.clientFrom || '-' }}</td>
              <td>{{ house.clientTo || '-' }}</td>
              <td>{{ house.billOfLading || '-' }}</td>
              <td>{{ house.freightTerms || '-' }}</td>
              <td>{{ equipmentList(house) || '-' }}</td>
              <td class="text-center">
                <v-btn icon x-small color="primary" @click="goToHouseBL(house)" class="ma-0">
                  <v-icon x-small>mdi-eye</v-icon>
                </v-btn>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-expand-transition>
</template>

<script>
export default {
  name: 'HouseBLExtension',
  props: ['open', 'houses'],
  data() {
    return {}
  },
  watch: {
    open(isOpen) {
      if (!isOpen) return
    },
  },
  methods: {
    goToHouseBL(house) {
      this.$router.push({
        name: 'houseBl',
        params: {id: house.id},
      })
    },
    equipmentList(houseBl) {
      if (!houseBl?.containers?.length) return ''

      return houseBl.containers
          .map(c => c.equipmentReference)
          .filter(Boolean)
          .join(', ')
    },
  },
}
</script>

<style scoped>
.house-table {
  background-color: transparent !important;
  border-left: 4px solid var(--v-primary-base);
}

.house-table thead tr {
  background-color: transparent !important;
}

.house-table tbody tr {
  outline: 1px solid rgba(0,0,0,0.06);
}

.house-table thead tr th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.15) !important;
  padding: 8px 12px !important;
  letter-spacing: 0.03em;
}

.house-table tbody tr td {
  padding: 6px 12px !important;  /* more breathing room */
  border-bottom: 1px solid rgba(0, 0, 0, 0.06) !important;
  color: rgba(0, 0, 0, 0.75);
  font-size: 0.8rem !important;
}
</style>
